// swiper.js                                                          ~/js/
///////////////////////////////////////////////////////////////////////////

import { GlobalHeroSwiper } from './global-hero';
import { GlobalImageSwiper } from './image';
import { GlobalArticleSwiper } from './global-article';
import { ActioncallSwiper } from './global-actioncall';
import { LandingExhibitSwiper } from './landing-exhibits';
import { VisitExhibitSwiper } from './visit-featured';
import { GlobalTheaterSwiper } from './global-theater';
import { EventsFeaturedSwiper } from './events-featured';
import { ExhibitHighlightsModalSwiper } from './exhibit-highlight-modal';
import { SoldierStorySwiper } from './soldier-story';
import { ExhibitSingleHighlightsSwiper } from './exhibit-single';
import { CollectionsSwiper } from './collections';
import { ArmyTrailsSwiper } from './army-trails';
import { ArmyTrailStopSwiper } from './army-trail-stop';

// OTHER JS (NOT SWIPER)

// The closing button on the exhibit highlights modal
document
  .querySelectorAll('.exhibit-highlights-modal-closer')
  .forEach((element) => {
    element.addEventListener('click', () => {
      if (!ExhibitHighlightsModalSwiper.el.classList.contains('hidden')) {
        ExhibitHighlightsModalSwiper.el.classList.add('hidden');
        ExhibitHighlightsModalSwiper.update();
      }
    });
  });

// The closing button on the soldier stories modal
document.querySelectorAll('.soldier-story-modal-closer').forEach((element) => {
  element.addEventListener('click', () => {
    if (!SoldierStorySwiper.el.classList.contains('hidden')) {
      SoldierStorySwiper.el.classList.add('hidden');
      SoldierStorySwiper.update();
    }
  });
});
